import React from 'react';

import styled from '@emotion/styled';

import { Box, COLORS, FontWeight, Text, mq } from '@clutter/clean';

import amex from '@images/icons/americanexpress_small.svg';
import maestro from '@images/icons/maestro_small.svg';
import mastercard from '@images/icons/mastercard_small.svg';
import poweredByStripe from '@images/icons/powered_by_stripe.svg';
import secure from '@images/icons/secure.svg';
import visa from '@images/icons/visa_small.svg';

const Secure = styled.img`
  margin-right: 12px;
`;

const PaymentCardContainer = styled.div`
  display: flex;
  gap: 10px;
  padding: 0 16px;
`;

const CardIcons = styled.img`
  ${mq({ height: ['20px', null, '24px'] })}
`;

/** Figma 707:5595 — SSL row + card brands + Stripe, no gray box. */
const ChallengerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`;

const ChallengerSsl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ChallengerSslLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family:
    'Avenir Next',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: ${FontWeight.Medium};
  line-height: 16px;
  color: #1f2f38;
`;

const ChallengerLock = styled.img`
  width: 24px;
  height: 24px;
  display: block;
`;

const ChallengerCards = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ChallengerCardIcon = styled.img`
  height: 20px;
  width: auto;
  display: block;
`;

export const CredibilityBanner: React.FC<{
  showCardIcons?: boolean;
  appearance?: 'classic' | 'challenger';
}> = ({ showCardIcons, appearance = 'classic' }) => {
  if (appearance === 'challenger') {
    return (
      <ChallengerRow>
        <ChallengerSsl>
          <ChallengerSslLabel>
            <ChallengerLock src={secure} alt="" />
            SSL secure payment
          </ChallengerSslLabel>
          {showCardIcons && (
            <ChallengerCards>
              <ChallengerCardIcon src={visa} alt="" />
              <ChallengerCardIcon src={mastercard} alt="" />
              <ChallengerCardIcon src={amex} alt="" />
              <ChallengerCardIcon src={maestro} alt="" />
            </ChallengerCards>
          )}
        </ChallengerSsl>
        <img height="24px" src={poweredByStripe} alt="Powered By Stripe" />
      </ChallengerRow>
    );
  }

  return (
    <Box.Flex
      background={COLORS.grayBackground}
      borderRadius="4px"
      padding="16px"
      alignItems="center"
      margin="24px 0"
      style={{ gap: '16px' }}
      flexWrap="wrap"
      flexDirection={showCardIcons ? ['column', null, 'row'] : 'row'}
    >
      <Box.Flex
        flexGrow={1}
        alignItems="center"
        justifyContent={['space-between', null, 'left']}
      >
        <Box.Flex>
          <Secure src={secure} alt="" />
          <Text.Caption>Secure & encrypted</Text.Caption>
        </Box.Flex>
        {showCardIcons && (
          <PaymentCardContainer>
            <CardIcons src={visa} alt="" />
            <CardIcons src={mastercard} alt="" />
            <CardIcons src={amex} alt="" />
            <CardIcons src={maestro} alt="" />
          </PaymentCardContainer>
        )}
      </Box.Flex>
      <img height="24px" src={poweredByStripe} alt="Powered By Stripe" />
    </Box.Flex>
  );
};
